$(document).ready(function() {
	$(document).on('click', '.cm-comparison-widget__header', function() {
		var box = $(this).parents('.cm-comparison-widget');
		if(!box.hasClass('active')) {
			box.addClass('active');
		} else {
			box.removeClass('active');
		}
	});

	$(document).on('click', '.cm-comparison-widget__icon', function() {
		var box = $(this).parents('.cm-comparison-widget');
		box.removeClass('active');
	});

	$(document).on('click', '.cm-comparison-widget .list__remove', function() {
		var box = $(this).parents('.cm-comparison-widget');
		var obj = $(this);
		var categoryId = obj.data('categoryId');
		var productId = obj.data('productId');
		

		$('.cm-comparison-widget').addClass('loading');
		$.ajax({
			url: window.location.href,
			type: 'POST',
			data: {
				cm_action: 'removeProductFromComparison',
				product_id: productId,
				category_id: categoryId,
			},
			dataType: 'JSON',
			success: function(response) {
				console.log(response, 'response');
				$('.cm-comparison-widget').html($(response.widget).html());
				$('.cm-comparison-widget').removeClass('loading');
			}
		})
	});


});